import { AxiosError, AxiosRequestConfig } from 'axios';
import {
  ICurrencyAvailability,
  ICurrencyExchangeRateUpdatePayload,
  ICurrencySearchItem,
  ICurrencyTableItem
} from 'types/currency.types';
import { apiGet, apiPostFile, apiPut } from '../api';

const { REACT_APP_ORGANIZATION } = process.env;

/** Busca monedas por información de búsqueda. */
export const searchCurrencies = async (query?: string): Promise<ICurrencySearchItem[]> => {
  const normalizedQuery = query?.trim();
  const searchQuery = normalizedQuery ? `?q=${encodeURIComponent(normalizedQuery)}` : '';

  return apiGet<AxiosRequestConfig, ICurrencySearchItem[]>(
    `${REACT_APP_ORGANIZATION}/currency/search${searchQuery}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

/** Obtiene las monedas disponibles para la organización en formato tabla. */
export const getCurrenciesTableListing = async (search?: string): Promise<ICurrencyTableItem[]> => {
  const normalizedSearch = search?.trim();
  const searchQuery = normalizedSearch ? `?search=${encodeURIComponent(normalizedSearch)}` : '';

  return apiGet<AxiosRequestConfig, ICurrencyTableItem[]>(
    `${REACT_APP_ORGANIZATION}/currency/currency-table-listing${searchQuery}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

/** Verifica si el código o nombre de moneda ya están registrados. */
export const checkCurrencyAvailability = async (params: {
  code?: string;
  name?: string;
}): Promise<ICurrencyAvailability> => {
  const queryParams = new URLSearchParams();

  if (params.code?.trim()) {
    queryParams.append('code', params.code.trim());
  }

  if (params.name?.trim()) {
    queryParams.append('name', params.name.trim());
  }

  const queryString = queryParams.toString();
  const availabilityQuery = queryString ? `?${queryString}` : '';

  return apiGet<AxiosRequestConfig, ICurrencyAvailability>(
    `${REACT_APP_ORGANIZATION}/currency/check-availability${availabilityQuery}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

/** Crea una moneda nueva con tasa de cambio inicial. */
export const createCurrencyWithExchange = async (formData: FormData): Promise<unknown> => {
  return apiPostFile<AxiosRequestConfig, unknown>(
    `${REACT_APP_ORGANIZATION}/currency/create-with-exchange`,
    formData,
    undefined,
    true
  );
};

/** Actualiza la tasa de cambio de una moneda. */
export const updateCurrencyExchangeRate = async (
  currencyId: number,
  body: ICurrencyExchangeRateUpdatePayload
): Promise<string> => {
  return apiPut<AxiosRequestConfig, ICurrencyExchangeRateUpdatePayload>(
    `${REACT_APP_ORGANIZATION}/currency/${currencyId}/exchange-rate`,
    body
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};
